import type { AccordionItemProps } from './Accordion.types'
import * as RadixCollapsible from '@radix-ui/react-collapsible'
import cn from 'classnames'
import { Icon } from '../icon'
import { Typography } from '../typography'
import styles from './Accordion.module.css'

export function Item({
  children,
  title,
  defaultOpen,
  onOpenChange,
  disabled,
  className,
  ...rest
}: AccordionItemProps) {
  return (
    <div className={cn(styles.item, className)} {...rest}>
      <RadixCollapsible.Root defaultOpen={defaultOpen} onOpenChange={onOpenChange} disabled={disabled}>
        <RadixCollapsible.Trigger className={styles.header}>
          <Typography variant="body-m-bold-tight">{title}</Typography>
          <Icon glyph="ChevronDown" size={24} aria-hidden className={styles.headerIcon} />
        </RadixCollapsible.Trigger>
        <RadixCollapsible.Content className={styles.collapsibleContent}>
          <Typography>{children}</Typography>
        </RadixCollapsible.Content>
      </RadixCollapsible.Root>
    </div>
  )
}

Item.displayName = 'Accordion.Item'

export function Root({ className, ...rest }: React.ComponentPropsWithoutRef<'article'>) {
  return <article className={cn(styles.root, className)} {...rest} />
}

Root.displayName = 'Accordion.Root'
